// filepath: c:\dev\WebModule\src\ui\DealerUI\src\localization\modules\module-registry.ts
import { ITranslationModule } from '../interfaces';
import { V6UpdateDefaultsModalModule } from './v6config/v6-quote-item/update-v6-defaults-modal-lang';
import { V6FrameConfigModule } from './v6-frame-config-module';

export function getV6FrameConfigLanguageModules(): ITranslationModule[] {
  const modules: ITranslationModule[] = [];

  modules.push(new V6FrameConfigModule());
  modules.push(new V6UpdateDefaultsModalModule());

  return modules;
}
